var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#036FE2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.08,
    fillRule: "nonzero",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 49.2L25.6 40l9.2-9.2L32 28 20 40l12 12 2.8-2.8zm10.4 0l9.2-9.2-9.2-9.2L48 28l12 12-12 12-2.8-2.8z"
  }))));
}

export default __webpack_public_path__ + "d7183246f50830a5765ec27e070c9e10.svg";
export { SvgCode as ReactComponent };